( function( app ) {
  const COMPONENT = {
    init: function() {
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'donate-cta', COMPONENT );
} )( app );
